/**
 * 老版本接口
 * https://www.kdocs.cn/l/cjo6dIQmMH0w
 */

import { ua } from '@/utils/tools'
function androidInvoke (api, json, callback) {
  if (!window?.WPSDoc?.invoke) {
    throw new Error('api unsupport')
  }
  window.WPSDoc.invoke('yun', api, JSON.stringify(json), callback)
}

function iosInvoke (json) {
  if (!window.webkit?.messageHandlers?.invokeKDocsApi?.postMessage) {
    throw new Error('api unsupport')
  }
  window.webkit.messageHandlers.invokeKDocsApi.postMessage(json)
}

function call (api: string, params = {}, options:{ isAndroid: boolean }):Promise<unknown> {
  const { isAndroid } = options
  return new Promise((resolve, reject) => {
    const callbackName = `${api.replace(/\./g, '_')}_` + Date.now()
    const onFailCallbackName = `fail_${callbackName}`

    window[callbackName] = (res) => {
      try {
        if (typeof res === 'string') {
          res = JSON.parse(res)
        }
        if (!isAndroid && res?.data) {
          res = res.data
        }
        const { code, result } = res || {}
        if (result === 'APINotExist' || (code && code !== 0)) {
          reject(res)
        } else { resolve(result || res) }
      } catch (e) {
        console.log('api error', e)
        reject(e)
      }
      delete window[callbackName]
      delete window[onFailCallbackName]
    }

    try {
      if (isAndroid) {
        androidInvoke(api, params, callbackName)
      } else {
        window[onFailCallbackName] = (res) => {
          reject(res)
          delete window[callbackName]
          delete window[onFailCallbackName]
        }
        const data = {
          apiName: api,
          params,
          onSuccess: callbackName,
          onFail: onFailCallbackName
        }
        iosInvoke(data)
      }
    } catch (e) {
      reject(e)
    }
  })
}

class OldBridge {
  apiList: string[]
  private isAndroid: boolean
  constructor (config:{isAndroid:boolean}) {
    this.apiList = []
    this.isAndroid = config.isAndroid
  }

  private async getApiList () {
    this.call('apiList').then(res => {
      this.apiList = res as string[]
    }).catch((e) => {
      console.log('apiList error', e)
    })
  }

  call (api, params = {}) {
    return call(api, params, { isAndroid: this.isAndroid })
  }

  async isSupport (api: string) {
    if (!this.apiList.length) {
      await this.getApiList()
    }
    return this.apiList.includes(api)
  }
}

export default new OldBridge({ isAndroid: !!ua.isAndroid })
